import { buildStudyMetadataPayload } from "./studyFormMetadataUtils";

const idToUpperCase = (value) =>
  value === undefined || value === null || value === ""
    ? ""
    : String(value).toUpperCase();

const staffRowToUser = (staff, isAssigned) => ({
  UserId: idToUpperCase(staff.value),
  UserName: (staff.userName ?? "").trim(),
  EmailId: (staff.emailId ?? "").trim(),
  IsAssigned: !!isAssigned,
});

export function buildStudyActivityUpdatePayload({
  userData,
  formData,
  assignedStaff = [],
  initialAssignedStaffIds = [],
  staffList = [],
}) {
  const studyNumDigitsOnly = String(formData.studyNumber ?? "")
    .replace(/\D/g, "")
    .trim();
  const colorHex =
    formData.studyColor &&
    (typeof formData.studyColor === "object"
      ? formData.studyColor.value
      : formData.studyColor);

  const userList = assignedStaff.map((staff) => staffRowToUser(staff, true));
  const currentIdSet = new Set(
    assignedStaff.map((staff) => String(staff.value).toLowerCase()),
  );
  const removedUserList = [];
  (initialAssignedStaffIds || []).forEach((rawId) => {
    const id = String(rawId).toLowerCase();
    if (currentIdSet.has(id)) return;
    const staff = staffList.find(
      (item) => String(item.value).toLowerCase() === id,
    );
    if (staff) removedUserList.push(staffRowToUser(staff, false));
  });

  const selectedSites = formData.selectedSites || [];
  const primarySiteId = selectedSites[0]?.value || "";

  return {
    OrganizationId: idToUpperCase(userData.OrganizationId),
    CreatedBy: idToUpperCase(userData.StaffId),
    StudyId: formData.studyId || "",
    Action: formData.studyId ? "Update" : "Insert",
    Study: (formData.studyTitle || "").trim(),
    StudyNum: studyNumDigitsOnly,
    PI: idToUpperCase(formData.principalInvestigator?.value),
    EudractNumber: (formData.eudractNumber || "").trim(),
    Randnumber: (formData.rdNumber || "").trim(),
    SiteID: String(primarySiteId).trim(),
    SiteList: selectedSites.map((site) => ({
      SiteId: idToUpperCase(site.value),
      SiteName: site.label || site.site?.SiteName || "",
    })),
    Department: formData.department ?? "",
    StudyColor: colorHex ?? "",
    Status: formData.status?.value ?? "Live",
    UserList: userList,
    RemovedUserList: removedUserList,
    StudyLocationList: [],
    ProjectId: "",
    SponsorName: (formData.sponsorName || "").trim(),
    IRASNumber: (formData.irasNumber || "").trim(),
    CordinatorName: (formData.cordinatorName || "").trim(),
    CordinatorPhone: (formData.cordinatorContact || "").trim(),
    CordinatorEmail: (formData.cordinatorEmail || "").trim(),
    ...buildStudyMetadataPayload(formData),
  };
}
